import { render, staticRenderFns } from "./MergeOrder.vue?vue&type=template&id=6f962100&scoped=true"
import script from "./MergeOrder.vue?vue&type=script&lang=js"
export * from "./MergeOrder.vue?vue&type=script&lang=js"
import style0 from "./MergeOrder.vue?vue&type=style&index=0&id=6f962100&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f962100",
  null
  
)

export default component.exports